import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { IUTLoadTrainRequest, IUTShipperProfile } from '@ruby/modules/unit-train/models/unit-train.interface';
import { UTAdvanceSearchActions, UTAdvanceSearchSelectors } from '@ruby/modules/unit-train/store/ut-advance-search.index';

@Component({
  selector: 'ng-ut-shipper-profile-container',
  templateUrl: './shipper-profile.container.html',
  styleUrls: ['./shipper-profile.container.scss']
})
export class ShipperProfileContainer {
  store$!: Observable<{ shipperProfiles: Array<IUTShipperProfile>; loadingShippers: boolean }>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IUTLoadTrainRequest,
    private dialogRef: MatDialogRef<ShipperProfileContainer>,
    private store: Store<{ shipperProfiles: Array<IUTShipperProfile>; loadingShippers: boolean }>
  ) {
    this.store$ = this.store.select(UTAdvanceSearchSelectors.selectUTAdvanceSearchState);
    this.store.dispatch(UTAdvanceSearchActions.fetchTrainShipperProfiles({ data }));
  }

  /**
   * Close Dialog
   *
   * @summary will close dialog
   * @param $data: IUTShipperProfile
   * @returns void
   */
  closeDialog($data: IUTShipperProfile): void {
    this.dialogRef.close($data);
  }
}
